module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step2-pict01-full-338bc1be7ad7a3d7ce70035be7b02cc3.jpg";